import { DropFile } from "components/DesignSystem/BaseFileInput/BaseFileInput";
import { CSV, EXCEL } from "constants/fileTypes";
import { getLocalFileKey } from "./getLocalFileKey";

const CSV_EXTENSION = ".csv";

export const toLocalDropFile = (file: File): DropFile => ({
  name: file.name,
  file_type: file.name.toLowerCase().endsWith(CSV_EXTENSION) ? CSV : EXCEL,
  is_previewable: false,
  uuid: getLocalFileKey(file),
});
